__webpack_require__.p = "/barbershopRK/";